import { Modal } from 'components/modal/modal'
import { ChangeEvent, useState } from 'react'
import { Button } from 'ui-kit/button'

import {
  ButtonContainer,
  Description,
  FeedbackTextarea,
  ModalContainer,
  SecondaryActions,
  TextActionButton,
  Title,
} from './product-feedback-modal.styles'

interface ProductFeedbackModalProps {
  isOpen: boolean
  onSubmit: (args: { feedback: string }) => void
  onAskMeLater: () => void
  onDismissForever: () => void
}

/**
 * Modal that collects open-ended product feedback from returning users.
 */
export const ProductFeedbackModal = ({
  isOpen,
  onSubmit,
  onAskMeLater,
  onDismissForever,
}: ProductFeedbackModalProps) => {
  const [feedback, setFeedback] = useState('')

  const handleSubmit = () => {
    onSubmit({ feedback })
  }

  const handleFeedbackChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setFeedback(e.target.value)
  }

  return (
    <Modal isOpen={isOpen} center fluid>
      <ModalContainer>
        <Title>We&apos;d appreciate your feedback</Title>
        <Description>
          When you have a moment, would you please share how Typing Mentor is working for you? We&apos;d be grateful to
          hear what you enjoy and what we could do better. Your thoughts help us improve for everyone.
        </Description>
        <FeedbackTextarea
          value={feedback}
          onChange={handleFeedbackChange}
          placeholder="Please share your feedback here..."
          rows={4}
        />
        <ButtonContainer>
          <Button variant="primary" onClick={handleSubmit}>
            Send feedback
          </Button>
        </ButtonContainer>
        <SecondaryActions>
          <TextActionButton type="button" onClick={onAskMeLater}>
            Maybe later
          </TextActionButton>
          <TextActionButton type="button" onClick={onDismissForever}>
            No thanks, don&apos;t ask again
          </TextActionButton>
        </SecondaryActions>
      </ModalContainer>
    </Modal>
  )
}
